import { HttpMethod, PaginationResponse } from '@aibees/shared/definition';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { NotificationItem, NotificationStatus } from '../types';
import { NOTIFICATION_API_PREFIX } from './constants';
import { useBrowseNotificationsApi } from './use-browse-notifications-api';
import { useBrowseNotificationsCountApi } from './use-browse-notifications-count-api';

export function useDeleteNotificationStatusMutationApi(id: string) {
  return useBaseMutation<any, PaginationResponse<NotificationItem>>(
    {
      url: `${NOTIFICATION_API_PREFIX}/${id}`,
      method: HttpMethod.delete,
    },
    {
      onSettled() {
        baseQueryClient.invalidateQueries([
          useBrowseNotificationsCountApi.name,
          NotificationStatus.ALL,
        ]);
        baseQueryClient.invalidateQueries([
          useBrowseNotificationsApi.name,
          0,
          { size: 25, statuses: NotificationStatus.ALL },
        ]);
      },
    }
  );
}
